import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import InputType from "common/form/InputType";
import IdName from "core/util/IdName";
import entityMeta from "../entityMeta";

@Entity(entityMeta.KB)
@Form()
export class KnowledgeBase {

	@Field()
	public id: any;

	@Field()
	public guid: string;

	@Field()
	@Input({type: InputType.TEXT, title: "Name"})
	public name: string;

	@Field()
	@Input({type: InputType.TEXT, title: "External ID"})
	public externalId: string;

	@Field()
	@Input({type: InputType.TEXT_HTML, title: "Description"})
	public description: string;

	@Field()
	@Input({type: InputType.UPLOAD_URL_IMAGE, title: "Logo"})
	public iconUrl: string;

	@Field({entity: IdName, params: { params: { topLevel: true } }})
	public categories?: null | IdName[];

}



// WEBPACK FOOTER //
// ./src/panels/kb/knowledgeBase/entities.ts